<template>
  <div class="outgoing-email-paginated-overview">
    <div class="filters">
      Per pagina
      <a-select :disabled="loading" :value="showPerPage['outgoing']" v-on:change="onPerPageChange">
        <a-select-option v-for="(option, index) in perPageOptions" :key="index" :value="option">
          {{ option }}
        </a-select-option>
      </a-select>

      <overview-filter-component :filter-sent-from="true" :filter-receiver="true" :filter-date-range="true"
                                 :filter-key-word="true" :filter-user="true"
                                 :disable-filters="loading"
                                 @filter-request="getFilteredEmails($event)"/>
    </div>

    <div class="paginator" v-if="showPagination">
      <laravel-pagination :data="currentRequestData" :loading="loading" :disable="loading"
                          @pagination-change-page="loadPage"/>
    </div>

    <table class="table table-striped">
      <thead>
      <tr>
        <th class="compact">
          <order-by :order="order" :select="orderBy" value="subject" @change="onOrderByChange"> Onderwerp</order-by>
        </th>
        <th class="compact">
          <order-by :order="order" :select="orderBy" value="from" @change="onOrderByChange"> Verzonden vanaf</order-by>
        </th>
        <th class="compact">
          <order-by :order="order" :select="orderBy" value="to" @change="onOrderByChange"> Ontvanger</order-by>
        </th>
        <th class="compact">
          <!--          FIXME: make user sortable by last name -->
          <!--          <order-by :order="order" :select="orderBy" value="user_id" @change="onOrderByChange"> -->
          Verzonden door
          <!--          </order-by>-->
        </th>
        <th class="compact">
          <!--          FIXME: make customer sortable by last name -->
          <!--          <order-by :order="order" :select="orderBy" value="customer_id" @change="onOrderByChange"> -->
          Klant
          <!--          </order-by>-->
        </th>
        <th class="compact">
          <order-by :order="order" :select="orderBy" value="date" @change="onOrderByChange">Datum</order-by>
        </th>
        <th class="compact"></th>
      </tr>
      <tr v-if="!hasEmails">
        <td colspan="6"> Geen e-mails gevonden.</td>
      </tr>
      </thead>

      <tbody>
      <RowComponent v-for="email in emails" :key="email.id" :email="email"
                    :show-column-from="true"
                    :show-column-to="true"
                    :show-breadcrumbs="true" v-bind:class="{ loading }"></RowComponent>
      </tbody>
    </table>

    <div class="paginator" v-if="showPagination">
      <laravel-pagination :data="currentRequestData" @pagination-change-page="loadPage"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import emailModule from '~/modules/email/store'
import store from '~/store'
import emailApi from '~/api/email'
import RowComponent from './RowComponent'
import OverviewFilterComponent from './OverviewFilterComponent'

export default {
  name: 'PaginatedOutgoingEmailComponent',
  components: {RowComponent, OverviewFilterComponent},
  props: {
    userId: {
      type: Number,
      required: true,
    },
    perPage: {
      type: [Number, String],
      default: 10,
    },
  },
  data() {
    return {
      perPageOptions: [5, 10, 15, 30, 50],
      loading: true,
      reloadTimeout: null,
      currentPage: null,
      currentRequestData: null,
      page: 1,
      orderBy: 'date',
      order: 'desc',
      filter: {},
      emails: [],
    }
  },
  computed: {
    ...mapState('email', [
          'name',
          'showPerPage',
        ],
    ),
    showPagination() {
      return this.hasEmails
    },
    hasEmails() {
      return this.emails.length > 0
    },
    hasPages() {
      if (!this.loading && this.currentRequestData.meta !== null && typeof this.currentRequestData !== 'undefined'
          && this.currentRequestData.meta.pagination !== null
          && typeof this.currentRequestData.meta.pagination !== 'undefined') {
        return this.currentRequestData.meta.pagination.total_pages > 1
      }
      return false
    },
    filterInitialized() {
      return Object.keys(this.filter).length > 0
    },
    filterActive() {
      if (Object.entries(this.filter)) {
        for (const [key, value] of Object.entries(this.filter)) {
          if (value !== null && value.length > 0) return true
        }
      }
      return false
    }
  },
  methods: {
    ...mapActions('email', [
      'setShowPerPage',
      'initialiseStore'
    ]),
    initEmails() {
      this.loadPage(this.page, true)
    },
    loadPage(page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) return
      this.loading = true
      emailApi.getPaginatedOutgoingByUser(
          this.userId,
          page,
          this.showPerPage['outgoing'],
          this.orderBy,
          this.order,
          ['customer', 'user'],
          this.filter,
      ).then(response => {
        this.currentRequestData = response
        this.emails = response.data
        this.currentPage = page
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt de e-mails op te halen.',
        })
      }).finally(() => {
        this.loading = false
      })
    },
    onPerPageChange(value) {
      this.setShowPerPage({key: 'outgoing', perPage: value})
      this.$nextTick(() => {
        this.loadPage(1, true)
      })
    },
    onOrderByChange(orderBy, order) {
      this.orderBy = orderBy
      this.order = order
      this.loadPage(this.currentPage, true)
    },
    getFilteredEmails(params) {
      this.filter = params
      this.loadPage(this.page, true)
    }
  },
  mounted() {
    let filteredOptions = this.perPageOptions.filter((option) => {
      return option == this.perPage
    })

    if (filteredOptions.length === 0) {
      this.perPageOptions.push(this.perPage)
      this.perPageOptions.sort((a, b) => a - b)
    }

    this.initEmails()
  },
  created() {
    if (!store.hasModule('email')) {
      store.registerModule('email', emailModule)
    }

    this.initialiseStore({key: 'outgoing', perPage: this.perPage})
  },
}
</script>

<style scoped>
.paginator {
  margin-left: 2rem;
}

.filters {
  display: inline-block;
  margin: 1rem 0 0 1rem;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tbody .loading {
  opacity: 0.8;
}

.no-mail-today {
  padding: 0 10px 15px;
}
</style>